<div class="shift-popup" [class.shift-popup--solo]="planetInfoKey() == null">
  <div class="shift-popup__cards">
    <div class="shift-popup__main">
      @if (cardData(); as cardData) {
        <hd-transit-info-card [data]="cardData" />
        <!-- Poort-links tussen de twee kaarten: prev/next enkel bij een ander
             poortnummer; "Meer over poort X" opent de volledige poort-details. -->
        <div class="shift-popup__links">
          @if (prevGateLink() != null) {
            <button type="button" class="shift-popup__more" (click)="openGateInfo(prevGateLink()!)">
              {{ prevGateLinkLabel() }}
            </button>
          }
          <button type="button" class="shift-popup__more" (click)="openGateInfo(cardData.current.gate)">
            {{ moreInfoLabel() }}
          </button>
          @if (nextGateLink() != null) {
            <button type="button" class="shift-popup__more" (click)="openGateInfo(nextGateLink()!)">
              {{ nextGateLinkLabel() }}
            </button>
          }
        </div>
      }
    </div>

    @if (planetInfoKey(); as planetKey) {
      <!-- Planet cheat-sheet card (bullets + cyclus-info); de links-rij blijft
           bij de info-card zodat die tussen de twee kaarten in komt te staan
           wanneer ze onder elkaar vallen. -->
      <hd-planet-card
        class="shift-popup__planet-info"
        [planetKey]="planetKey"
        [compact]="true"
      />
    }
  </div>
</div>
